export default {
  computed: {
    pageTemplate() {
      let template = this.category?.template || "category-med";

      if (this.category.templateModel.templateModelId == 1100) {
        template = "category-main";
      } else if (this.category.templateModel.templateModelId == 1101) {
        template = "category-med";
      } else if (this.category.templateModel.templateModelId == 1105) {
        template = "category-med";
      } else if (this.category.templateModel.templateModelId == 6001) {
        template = "category-med";
      } else if (this.category.templateModel.templateModelId == 6002) {
        template = "category-med";
      } else if (this.category.templateModel.templateModelId == 6003) {
        template = "category-med";
      }

      return () => import(`@/components/category/${template}.vue`);
    }
  }
};
